import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: '#f3f6f9',
                textAlign: 'center',
                px: 2,
            }}
        >
            <Box
                variant="h6"
                sx={{
                    fontSize: '25px',
                    fontWeight: 'bold',
                    mb: 2,
                    color: '#333',
                }}
            >
                Page Not Found
            </Box>

            <Typography
                variant="body1"
                sx={{ mb: 4, maxWidth: '420px', color: '#555' }}
            >
                The page you're looking for doesn't exist, was removed, or is temporarily unavailable.
            </Typography>

            <Button
                variant="contained"
                size="small"
                onClick={() => navigate('/dashboard')}
                sx={{
                    mt: '15px',
                    backgroundColor: '#f9a825',
                    color: '#fff',
                    fontWeight: 'bold',
                    px: 4,
                    py: 1.5,
                    textTransform: 'none',
                    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
                    '&:hover': {
                        backgroundColor: '#f57f17',
                    },
                }}
            >
                Back to Dashboard
            </Button>
        </Box>
    );
};

export default NotFound;
